import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Observable } from 'rxjs';

import { VaService } from '../_services/va.service';


@Injectable()
export class InstructorGuardService implements CanActivate {
  constructor(
    private router: Router,
    public vaService: VaService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any  {

    // return new Promise((resolve, reject) => {
    //   console.log(this.vaService.activeAgent)
    //     if (!this.vaService.activeAgent) {
    //         resolve(true);
    //     } else {
    //       this.vaService.getUserRole(this.vaService.activeAgent._id.$oid).subscribe((response: any) => {
    //         if (response.user.role !== 'instructor' && this.vaService.activeAgent['project_type'] !== 'universal') {
    //             resolve(true);
    //             return true;
    //         } else {
    //             this.router.navigate(['/list-va']);
    //             reject(false);
    //             return false
    //         }
    //       })
    //     }
    // });
    if (this.vaService.activeAgent && this.vaService.activeAgent.role === 'instructor' &&
     this.vaService.activeAgent.project_type !== 'universal') {
      this.vaService.activeAgent.role = '';
      this.router.navigate(['/list-va']);
      return false;
    } else {
      return true;
    }







  }

}




